import { Box, Divider } from '@mui/material';
import { styled } from '@mui/material/styles';
import TextField from 'components/formik/TextField';
import { Field, Form } from 'formik';
import { func, object, string } from 'prop-types';
import React, { Component } from 'react';
import attachmentShape from 'shapes/attachment';
import messageShape from 'shapes/message';
import { I18n } from 'utils/i18n';
import PdfPreview from '../../../PdfPhonePreview';
import Actions from './Actions';
import connector from './connector';
import DiscardButton from './DiscardButton';
import DraftButton from './DraftButton';
import formik from './formik';
import PublishButton from './PublishButton';
import Title from './Title';

const StyledForm = styled(Form)({
  width: '80vw',
  maxWidth: '850px',
  minHeight: '620px',
  display: 'flex',
  flexDirection: 'column',
});

class PreviewModalForm extends Component {
  saveAsDraft = async e => {
    const { setFieldValue, submitForm, onClose } = this.props;
    setFieldValue('isDraft', true);
    await Promise.resolve();
    submitForm(e);
    onClose();
  };

  discard = () => {
    const { message, onClose, actions } = this.props;

    if (message) actions.messages.destroy(message._id);

    onClose();
  };

  getPdf = () => {
    const { message, tempAttachment } = this.props;
    if (!message) return tempAttachment.httpLink;
    return message.attachments[0].httpLink;
  };

  render() {
    return (
      <StyledForm>
        <Box sx={{ flex: 1, p: '25px 15px' }}>
          <Title>{I18n.t('AcknowledgementCreate.Acknowledge message title')}</Title>
          <Box sx={{ m: '0 0 25px', width: '100%' }}>
            <Field
              component={TextField}
              name="title"
              placeholder={I18n.t('AcknowledgementCreate.Acknowledge document title')}
            />
          </Box>
          <PdfPreview src={this.getPdf()} />
        </Box>
        <Divider light />
        <Actions>
          <DiscardButton type="reset" onClick={this.discard} />
          <div>
            <DraftButton onClick={this.saveAsDraft} />
            <PublishButton type="submit" />
          </div>
        </Actions>
      </StyledForm>
    );
  }
}

PreviewModalForm.propTypes = {
  tempAttachment: attachmentShape,
  message: messageShape,
  onClose: func.isRequired,
  setFieldValue: func.isRequired,
  submitForm: func.isRequired,
  actions: object.isRequired,
  values: object.isRequired,
  companyId: string.isRequired,
  channel: object.isRequired,
};
PreviewModalForm.defaultProps = {
  tempAttachment: null,
  message: null,
};

export default connector(formik(PreviewModalForm));
